import React, { FC, ReactNode } from "react";
import { COOKIE_CURRENCY, CURRENCIES, CURRENCY_BY_LOCALE } from "@constants";
import { useCookie } from "@helpers/hooks/useCookie";
import { useRouter } from "next/router";
import cookies from "@helpers/cookies";
import { getCurrencySymbol } from "@helpers/getCurrencyFormat";
import Modal from "@components/ui/Modal";
import { usePreferences } from "@helpers/hooks/usePreferences";
import { useLocales } from "@helpers/hooks/useLocales";

const Preferences = () => {
  const { openModalPreferences } = usePreferences();

  const { locale } = useLocales();

  const currentLanguage = locale.toUpperCase();

  const currentCurrency = useCookie(
    COOKIE_CURRENCY,
    CURRENCY_BY_LOCALE[
      currentLanguage.toLowerCase() as keyof typeof CURRENCY_BY_LOCALE
    ]
  );

  return (
    <div
      className="whitespace-nowrap cursor-pointer"
      onClick={openModalPreferences}
    >
      {currentCurrency} ({getCurrencySymbol(currentCurrency)})
    </div>
  );
};

const Title: FC<{ children: ReactNode }> = ({ children }) => (
  <h3 className="text-base mb-2 text-gray-600 uppercase">{children}</h3>
);

const List: FC<{ children: ReactNode }> = ({ children }) => (
  <ul className="flex flex-wrap">{children}</ul>
);

const Item: FC<{ onClick?: () => void; children: ReactNode }> = ({
  children,
  ...props
}) => (
  <li
    className="w-1/3 md:w-1/4 pb-4 text-link hover:text-link-dark hover:underline cursor-pointer"
    {...props}
  >
    {children}
  </li>
);

export const PreferenceModal = () => {
  const router = useRouter();
  const { closeModalPreferences } = usePreferences();

  return (
    <Modal title="Preferences" onClose={closeModalPreferences}>
      <div>
        <Title>CURRENCIES</Title>
        <List>
          {CURRENCIES.map((currency) => (
            <Item
              key={currency}
              onClick={() => {
                cookies().set(COOKIE_CURRENCY, currency);
                router.reload();
              }}
            >
              {currency} ({getCurrencySymbol(currency)})
            </Item>
          ))}
        </List>
      </div>
    </Modal>
  );
};

export default Preferences;
